import { store } from "store/store";
import { newNotification } from "components/common/Notification/actions";

export const dispatchNotification = (payload) => {
  const notification = JSON.parse(payload.data?.payload || "{}")?.data;
  if (!notification) return;

  store.dispatch(newNotification(notification));
};
